import { render, staticRenderFns } from "./CityTable.vue?vue&type=template&id=cc85e5f8&scoped=true&"
import script from "./CityTable.vue?vue&type=script&lang=js&"
export * from "./CityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc85e5f8",
  null
  
)

export default component.exports